export class Line {
  id:   number;
  name: string;

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/app/models/line.model.ts